import axios from 'axios'
import { UrlPath } from './constant'
import Cookies from 'universal-cookie'
import CryptoJs from 'crypto-js'

export let APP_TOKEN = null
export let REDIRECT_URI = null
export let BASE_URL = null
export let COOKIE = {}

export const setAppToken = (clientId, clientSecret, redirectUri) => {
  APP_TOKEN = window.btoa(`${clientId}:${clientSecret}`)
  REDIRECT_URI = redirectUri
}

export const cookieValues = (loginState, user) => {
  COOKIE = {
    loginState: loginState,
    user,
    user
  }
}

export const setBaseUrl = (url) => {
  BASE_URL = url
}

export const getBaseUrl = () => {
  if (BASE_URL) {
    return BASE_URL
  }
}

function getFormBodyFromJson(details) {
  var formBody = []
  for (var property in details) {
    var encodedKey = encodeURIComponent(property)
    var encodedValue = encodeURIComponent(details[property])
    formBody.push(encodedKey + '=' + encodedValue)
  }
  formBody = formBody.join('&')
  return formBody
}

export const fetchLoginInfoFromServer = (token) => {
  const url = `${BASE_URL}${UrlPath.authCodeUrl}`
  const body = { redirect_uri: `${REDIRECT_URI}` }
  const headers = {
    'auth-code': token
  }
  return axios.post(url, getFormBodyFromJson(body), {
    headers: headers
  })
}

export const sendOTP = (mobileNo, countryCallingCode) => {
  const url = `${BASE_URL}${UrlPath.sendOTPUrl}`
  return axios.post(url, {
    number: mobileNo,
    countryCallingCode: countryCallingCode
  })
}

export const validateOtp = (otp, mobileNo, countryCallingCode) => {
  const url = `${BASE_URL}${UrlPath.validateOTPUrl}`
  const params = new window.URLSearchParams({
    otp: otp,
    mobile: mobileNo,
    countryCallingCode: countryCallingCode
  })
  return axios.get(url, {
    params: params
  })
}

export const validateUser = (userId, staticPassword) => {
  const url = `${BASE_URL}${UrlPath.userLoginUrl}`
  const body = { userId, staticPassword }
  const formdata = new window.FormData()
  formdata.append('data', encryptString(JSON.stringify(body)))
  return axios.post(url, formdata)
}

export const resetPassword = (userId, currentPassword, newPassword) => {
  const url = `${BASE_URL}${UrlPath.resetPwUrl}`
  const body = { userId, currentPassword, newPassword }
  const formdata = new window.FormData()
  formdata.append('data', encryptString(JSON.stringify(body)))
  return axios.put(url, formdata)
}

export const fetchAccessToken = (userName, password) => {
  const url = `${BASE_URL}${UrlPath.tokenUrl}`
  const body = {
    username: userName,
    password: password,
    grant_type: 'password'
  }
  return axios
    .post(url, getFormBodyFromJson(body), {
      headers: {
        Authorization: `Basic ${APP_TOKEN}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      console.log(response)
      if (response && response.data) {
        const token = response.data.access_token
        const refreshToken = response.data.refresh_token
        updateUserLoginState(token, refreshToken)
        return response.data
      }
      return false
    })
    .catch((err) => {
      return err
    })
}

export function updateUserLoginState(token, refreshToken) {
  return new Promise((resolve, reject) => {
    try {
      window.localStorage.setItem('token', token)
      window.localStorage.setItem('refresh_token', refreshToken)

      if (token) {
        var decodedValue = parseJwt(token)
        setCookiesValue(decodedValue.userId)
        window.localStorage.setItem('userId', decodedValue.userId)
        window.localStorage.setItem('userName', decodedValue.user_name)
        resolve(true)
      } else {
        resolve(true)
      }
    } catch (err) {
      reject(err)
    }
  })
}

export const setCookiesValue = (userId) => {
  const cookies = new Cookies()
  var currentDate = new Date()
  var expirationDate = new Date()
  expirationDate.setDate(currentDate.getDate() + 7)
  var encryptedUserCookie = encryptString(userId + '')
  cookies.set(COOKIE.user, encryptedUserCookie, {
    domain: '.chalo.com',
    expires: expirationDate
  })
  var encryptedLoginCookie = encryptString('loggedIn')
  cookies.set(COOKIE.loginState, encryptedLoginCookie, {
    domain: '.chalo.com',
    expires: expirationDate
  })
}

function parseJwt(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}

export function encryptString(stringToEncrypt) {
  var key = CryptoJs.enc.Utf8.parse('web_chalo_appkey')
  var encryptedString = CryptoJs.AES.encrypt(stringToEncrypt, key, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.ZeroPadding
  })
  return encryptedString.toString()
}
